import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class ModifierService extends HttpService {
	/**
	 * Modifier Groups
	 */
	@GET('modifierGroup/list')
	@Adapter(null, { isAdmin: true })
	getModifierGroups(): Observable<any> {
		return null;
	}

	@GET('modifiergroup/selectionlist')
	@Adapter(null, { isAdmin: true })
	getModifierGroupSelections(): Observable<any> {
		return null;
	}

	@GET('modifierGroup/getbyid')
	@Adapter(null, { isAdmin: true })
	getModifierGroup(@Query('id') id: number): Observable<any> {
		return null;
	}

	@POST('modifierGroup/create')
	@Adapter(null, { isAdmin: true })
	createModifierGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST('modifierGroup/update')
	@Adapter(null, { isAdmin: true })
	updateModifierGroup(@Body data: string): Observable<any> {
		return null;
	}

	@POST('modifierGroup/delete')
	@Adapter(null, { isAdmin: true })
	deleteModifierGroup(@Body data: string): Observable<any> {
		return null;
	}

	/**
	 * Modifier
	 */
	@GET('modifier/list')
	@Adapter(null, { isAdmin: true })
	getModifiers(): Observable<any> {
		return null;
	}

	@GET('modifier/getbyid')
	@Adapter(null, { isAdmin: true })
	getModifierById(@Query('id') id: number): Observable<any> {
		return null;
	}

	@POST('modifier/create')
	@Adapter(null, { isAdmin: true })
	createModifier(@Body data: string): Observable<any> {
		return null;
	}

	@POST('modifier/update')
	@Adapter(null, { isAdmin: true })
	updateModifier(@Body data: string): Observable<any> {
		return null;
	}

	@POST('modifier/delete')
	@Adapter(null, { isAdmin: true })
	deleteModifier(@Body data: string): Observable<any> {
		return null;
	}
}
